<div class="scrollable-content simulator">
  <div class="content-wrapper">
    <app-breadcrumb></app-breadcrumb>
    <app-header></app-header>
    <div class="main-content">
      @if (loaderService.isLoading()) {
        <app-loader></app-loader>
      }
      <div @fadeInFadeOut [hidden]="loaderService.isLoading()">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
<lib-salesforce-chat [lang]="translateService.currentLang" [customerType]="customerType"> </lib-salesforce-chat>
